import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-text-toggle',
  templateUrl: './text-toggle.component.html',
  styleUrls: ['./text-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TextToggleComponent
    }
  ]
})
export class TextToggleComponent implements ControlValueAccessor, OnInit, OnChanges, AfterViewInit {
  @Input() selectedItemIndex?: number;
  @Input() items!: string[];
  @Input() highlightSelected = false;
  @Input() showDividers = false;

  @Input() dayWasClicked!: boolean;
  @Input() disabled = false;

  @Output() onSelected = new EventEmitter<string>();

  @ViewChild('container') container!: ElementRef;

  touched = false;
  resizeObserver!: ResizeObserver;

  _selectedItemIndex!: number;
  itemsSizeInfo: { x: number, width: number }[] = [];

  onChange = (value: any) => {};
  onTouched = () => {};

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this._selectedItemIndex = this.selectedItemIndex ?? 0;
    this.itemsSizeInfo = this.items.map(() => ({ x: 0, width: 0 }));
  }

  ngAfterViewInit(): void {
    this.setResizeObserver();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedItemIndex) {
      this._selectedItemIndex = changes.selectedItemIndex.currentValue;
    }

    if (changes.items?.currentValue && changes.items.previousValue) {
      this.itemsSizeInfo = changes.items.currentValue.map(() => ({ x: 0, width: 0 }));
      this.cd.detectChanges();
      this.setResizeObserver();
    }
  }

  setResizeObserver() {
    this.resizeObserver?.disconnect();
    this.resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      const selectedBlock = this.container.nativeElement.querySelector('.selected-block');
      selectedBlock?.classList.add('no-transition');
      for (const entry of entries) {
        const index = +entry.target.getAttribute('index')!;
        this.itemsSizeInfo[index].width = entry.borderBoxSize[0].inlineSize;
      }
      for (let i = 1; i < this.itemsSizeInfo.length; i++) {
        this.itemsSizeInfo[i].x = this.itemsSizeInfo[i - 1].x + this.itemsSizeInfo[i - 1].width;
      }
      this.cd.detectChanges();
      setTimeout(() => selectedBlock?.classList.remove('no-transition'));
    });

    this.container?.nativeElement.querySelectorAll('.item').forEach((item: HTMLElement) => {
      this.resizeObserver.observe(item);
    });
  }


  changeItem(index: number) {
    this.markAsTouched();
    this.writeValue(this.items[index]);
    this.onChange(this.items[index]);
  }

  writeValue(value: string) {
    const index = this.items.indexOf(value);
    if (index === -1) {
      return;
    }
    this.onSelected.emit(value);
    this._selectedItemIndex = index;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
